import { api } from "@";

// Fetches the social media statistics
export const getServicesConnection = () =>
  api.get(`/api/AdminSocialMediaStatistics`);

// Saves the social media statistics
export const saveServicesConnection = (data) =>
  api.post(`/api/AdminSocialMediaStatistics`, data);
